export const INACTIVE_CART_MESSAGE = 'Current user does not have an active cart.';
export const COULD_NOT_FIND_CART_MESSAGE = 'Could not find a cart with ID';

// Full message: Unable to place order: Phương thức giao hàng không có sẵn. Vui lòng thử lại.
export const UNAVAILABLE_SHIPPING_METHOD = 'Unable to place order';
export const MISSING_SHIPPING_ADDRESS = 'The shipping address is missing';
